import Scroll from './scroll'
import { connect } from 'react-redux'

import { setOffsetTop } from '../../../../../common/actions/layout'

const mapStateToProps = (state, ownProps) => {
  const { layout: { selectedItemId, offsetTop } } = state

  return {
    selected: selectedItemId === ownProps.itemId,
    offsetTop
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setOffsetTop: offsetTop => {
      dispatch(setOffsetTop(offsetTop))
    }
  }
}

const ScrollContainer = connect(mapStateToProps, mapDispatchToProps)(Scroll)

export default ScrollContainer
